import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';

const styles = (theme) => ({
	sectionHeader: {
		margin: '50px 0px 0px 0px',
		textAlign: 'left',
		textTransform: 'uppercase',
		letterSpacing: 1,
		fontFamily: `Roboto,sans-serif`,
		color: '#999',
		fontWeight: 100,
		fontSize: 28,
		[theme.breakpoints.up('md')]: {
			fontSize: 36,
		},
		// borderBottom: '1px solid #eee',
	},
});

class FMPRegionHeader extends Component {
	render() {
		const { label, classes, isTop, isSmaller } = this.props;

		const style = isTop ? { marginTop: 8 } : {};
		style.fontSize = isSmaller ? 22 : undefined;
		return (
			<div className={classes.sectionHeader} style={style}>
				{label}
			</div>
		);
	}
}

FMPRegionHeader.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	classes: PropTypes.object.isRequired,
	isTop: PropTypes.bool,
	isSmaller: PropTypes.bool,
};

export default _.flow([withStyles(styles)])(FMPRegionHeader);
